import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Select, Input, CheckBox } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder'

const CustomerPaid = _ => {
    const [ready, setReady] = useState(false)
    const [isProcessing, setIsProccesing] = useState(false)
    const [periodSelected, setPeriodSelected] = useState({})
    const [rows, setRows] = useState([])
    const [period, setPeriod] = useState([])
    const [csvFile, setCsvFile] = useState(null)
    const [closePeriod, setClosePeriod] = useState(false)

    const loadAll = _ => {
        setReady(false)
        setRows([])
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
            setReady(true)
        })
    }

    useEffect(() => {
        loadAll()
    }, [])

    const handleSubmit = _ => {
        if (parseInt(periodSelected.customers_paid) === 0) {
            if (!periodSelected) {
                Helpers.toast.construct({ response: 'warning', message: 'Seleccionar periodo', toast })
                return;
            }

            let data = new FormData()
            data.append('p_id_period', periodSelected.value)
            data.append('p_customers_paid', closePeriod ? 1 : 0)
            data.append('p_csv', csvFile.files[0])

            setIsProccesing(true)
            Controllers.report.customers_paid_insert(data).then(res => {
                if (res.response !== 'success') {
                    Helpers.toast.construct({ response: res.response, message: res.message, toast })
                    return;
                }
                Helpers.toast.construct({ response: 'success', message: res.message, toast })
                /* getPagos(periodSelected) */
                const auxPeriodSelected = { ...periodSelected }
                loadAll()
                setPeriodSelected(auxPeriodSelected)
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                })
        }
    }

    const dtRows = useMemo(() => {
        return <ReactDataTableBootstrap
            head={[
                [
                    { name: 'name_branch_office', text: 'Sucursal' },
                    { name: 'id_customers', text: 'ID', align: 'center' },
                    { name: 'full_name_customers', text: 'Nombres' },
                    { name: 'amount_paid', text: 'Monto pagado' },
                    { name: 'code_money', text: 'Moneda' },
                    { name: 'date_pay', text: 'Fecha Pago' },
                ],
            ]}
            rows={rows}
            pageLength={100}
            isProcessing={isProcessing}
        />
    }, [rows, isProcessing])

    const cboPeriodSelected = useMemo(() => {
        if (!periodSelected) {
            return
        }

        let finded = period.find(t => parseInt(periodSelected) === parseInt(t.id_type_price))

        if (!finded) {
            return
        }
        return {
            label: finded.name_price,
            value: finded.id_type_price,
            customers_paid: finded.customers_paid
        }
    }, [periodSelected, period])

    const getPagos = (e) => {
        setPeriodSelected(e)
        setRows([])
        setIsProccesing(true)
        Controllers.report.get_customers_paid({
            p_id_period: e.value
        }).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card>
                <Card.Header className="justify-content-between">
                    <span>Reporte Pago Clientes</span>
                </Card.Header>
                <Card.Body>
                    <FormCustom textButton="Procesar CSV" onSubmit={handleSubmit} viewSubmit={parseInt(periodSelected.customers_paid) === 0} className="mb-4" loadSubmit={isProcessing}>
                        <Select
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period,
                                    customers_paid: p.customers_paid
                                }
                            })}
                            value={cboPeriodSelected}
                            onChange={e => {
                                getPagos(e)
                            }}
                        />
                        {parseInt(periodSelected.customers_paid) === 0 && <>
                            <Input
                                type="file"
                                text="CSV"
                                classNameParent="col-12 mb-2"
                                accept="*.csv"
                                onChange={e => setCsvFile(e.currentTarget)}
                                required
                                invalid={"Seleccionar CSV"}
                            />
                            <CheckBox
                                id={'close-period'}
                                classNameParent="col-12 mb-2"
                                onChange={e => {
                                    setClosePeriod(e.currentTarget.checked)
                                }}
                                checked={closePeriod}
                                text="Cerrar periodo"
                            />
                        </>}

                    </FormCustom>
                    {periodSelected?.value && dtRows}
                </Card.Body>
            </Card>
        </ReactPlaceholder>
    </>
}

export default CustomerPaid